import '../polyfills';
import { NoDblClickDirective } from './directives/no-dbl-click.directive';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CdkTableModule } from '@angular/cdk/table';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { LoginComponent } from './login/login.component';
import { RouterModule, Routes } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { SnackBarMessageComponent } from './manage/manage.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { HomeComponent } from './home/home.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from './services/auth.service';
import { JwtInterceptor } from './_helpers/jwt.interceptor';
import { SubscriptionComponent } from './subscription/subscription.component';
import { ManageComponent, ManageDialogComponent } from './manage/manage.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { QuestionableBooleanPipe, PhonePipe } from './_helpers/pipes.pipe';
import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatDividerModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatCommonModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatStepperModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatOptionModule,
} from '@angular/material';
const appRoutes: Routes = [
  { path: 'login', component: LoginComponent },
  // { path: 'home', component: HomeComponent },
  // { path: 'createAccount', component: CreateAccountComponent },
  { path: 'subscription', component: SubscriptionComponent },
  { path: 'manage', component: ManageComponent },



  // { path: 'hero/:id',      component: HeroDetailComponent },
  // {
  //   path: 'heroes',
  //   component: HeroListComponent,
  //   data: { title: 'Heroes List' }
  // },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  { path: '**', component: ManageComponent }
];

@NgModule({
  exports: [
    NoDblClickDirective,
    CdkTableModule,
    MatAutocompleteModule,
    MatButtonModule,
    BrowserAnimationsModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatSelectModule,
    MatOptionModule,
  ],
  declarations: [
    NoDblClickDirective,
    SnackBarMessageComponent,
    AppComponent,
    LoginComponent,
    PageNotFoundComponent,
    HomeComponent,
    SubscriptionComponent,
    ManageComponent,
    QuestionableBooleanPipe,
    ManageDialogComponent,
    PhonePipe



  ],
  imports: [
    NgbModule.forRoot(),
    MatTabsModule,
    BrowserModule,
    MatButtonModule,
    MatToolbarModule,
    MatInputModule,
    MatMenuModule,
    MatFormFieldModule,
    MatIconModule,
    MatOptionModule,
    BrowserAnimationsModule,
    MatSelectModule,
    BrowserModule,
    MatExpansionModule,
    FormsModule,
    MatNativeDateModule,
    MatCardModule,
    MatGridListModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatListModule,
    MatDialogModule,
    MatProgressBarModule,
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: false } // <-- debugging purposes only
    )
  ],
  entryComponents: [
    ManageDialogComponent,
    SnackBarMessageComponent
  ],
  providers: [
    AuthService,
  CookieService,

    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    }
   ,
  ]
  ,
  bootstrap: [AppComponent]
})
export class AppModule {}
